import React from 'react';
import ReactDOM from 'react-dom';
import Authentication from './modules/authentication/Authentication/Authentication';
import reportWebVitals from './reportWebVitals';
// Design System
import './styles/design_system/main.scss';
import App from './App';
// inject i18  config to the app
import i18n from './assets/i18/config';
import { I18nextProvider } from 'react-i18next';

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
